import React from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import aboutimg from "../../../Image/aboutimg.png"
import { BsJournals } from 'react-icons/bs';
import { FaUserFriends } from 'react-icons/fa';
import { SlArrowLeft } from 'react-icons/sl';

const NeetCards = ({ courses, heading }) => {
    const location = useLocation();
    const navigate = useNavigate();
    function isValidUrl(string) {
        try {
            new URL(string);
            return true;
        } catch (_) {
            return false;
        }
    }
    return (
        <>
            <div className='AllCardBackground'>
                <div className="d-flex justify-content-between align-items-center p-2 py-1 mb-3 bg-light border rounded shadow-sm">
                    <button
                        className="btn btn-sm"
                        style={{
                            backgroundColor: '#17a2b8',
                            color: 'white',
                            fontWeight: 'bold',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '5px',
                            padding: '4px 12px',
                            border: 'none',
                            borderRadius: '4px',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                            cursor: 'pointer'
                        }}
                        onClick={() => navigate(-1)}
                    >
                        <SlArrowLeft /> Back
                    </button>
                    <h2 className="mb-0 fs-5" style={{ color: 'rgb(183, 6, 6)', fontWeight: 600, letterSpacing: '0.5px', textShadow: '0 1px 1px rgba(0,0,0,0.1)', lineHeight: '1.2' }}>{heading}</h2>
                    <Link to={'/StudentDashboard'} state={{ prePath: location.pathname, moduleName: 'neet' }} style={{ textDecoration: 'none', color: '#17a2b8', fontWeight: 'bold' }}>Dashboard</Link>
                </div>
                {/* <h1
                    className="fw-bold fs-4 text-center py-0 my-0 text-uppercase text-danger border-bottom border-2 mb-3"
                >
                    {heading}
                </h1> */}

                <div className="px-3" style={{ textAlign: "justify", lineHeight: "1.6" }}>
                    <p>
                        Every year, over <strong>15 lakh aspirants</strong> appear for the
                        <strong> National Eligibility cum Entrance Test (NEET)</strong> to pursue
                        their dream of becoming a <strong>Doctor</strong>. However, only a few of
                        them succeed in cracking India’s single largest medical entrance examination.
                    </p>

                    <p>
                        Therefore, we are introducing a <strong>Foundation Course for NEET from
                            Class 9th</strong>. Starting NEET preparation from Class 9 is the
                        <strong> first step in the field of Medical Science</strong>. Class 9 is the
                        perfect time to choose a career path, and beginning NEET preparation at this
                        stage helps aspirants build a strong foundation in their basic concepts.
                    </p>

                    <p>
                        Preparing for NEET from Class 9 assists aspirants in becoming better oriented
                        with the future courses they will need to study. The fundamental concepts
                        learned in Class 9 reduce the additional pressure faced during Class 12 board
                        examinations.
                    </p>

                    <p>
                        Students preparing for NEET from Class 9 have more time to plan their
                        preparation strategy effectively. NEET is one of the most competitive
                        entrance examinations, requiring <strong>focus, discipline, and a deep
                            understanding</strong> of both theoretical and practical aspects. A
                        well-structured study plan helps students excel not only in NEET but also in
                        their school and board exams.
                    </p>

                    <ul className="mt-3 ps-3 mb-0">
                        <li className="mb-2">
                            <strong>Coverage of Basic Concepts:</strong> NCERT books from Class 9 to 12
                            are thoroughly covered so students do not face any difficulty in Classes 11
                            and 12 during the peak of their preparation.
                        </li>
                        <li className="mb-2">
                            <strong>Expert Faculty:</strong> Our institute has the
                            <strong> best faculty for all subjects</strong>, ensuring that students can
                            clear all fundamental concepts before moving to advanced-level topics.
                        </li>
                        <li className="mb-2">
                            <strong>Integrated Test Series:</strong> Designed by expert faculty members,
                            the test series includes both <strong>objective and subjective</strong>
                            patterns, helping students perform exceptionally well in school and board
                            examinations.
                        </li>
                    </ul>
                </div>

                <div className='AllCard_Box'>
                    {courses.map((card, index) => (
                        <div className="card Allcard AllDashboard" key={index}>
                            <Link to={`/neet/course/${card.TitleHeading}`} /* state={{ isEnrolled: card.isEnrolled }} key={index} */ className='text-decoration-none text-black'>
                                <img src={isValidUrl(card.Image) ? card.Image : aboutimg} className="card-img-top" alt={card.CourseTitle} style={{ height: "140px" }} />
                            </Link>
                            <div className="card-body All-bg">
                                <Link to={`/neet/course/${card.TitleHeading}`} /* state={{ isEnrolled: card.isEnrolled }} key={index} */ className='text-decoration-none text-black'>
                                    {card.CourseTitle ? <h6 className="fw-bold overflow-hidden" style={{}}>{card.CourseTitle}</h6> : <h6 className="fw-bold overflow-hidden" style={{}}>{card.Title}</h6>}
                                </Link>
                                <hr />
                                <div className="d-flex justify-content-between align-items-center">
                                    <Link to="#" className="card-link list-group-item">
                                        <h6 className='d-flex align-items-center'><BsJournals className='me-1' />{`${card.TopicCount || 0} LESSONS`}</h6>
                                        {card.Subscriber && <h6 className='d-flex align-items-center'><FaUserFriends className='me-1' /> {card.Subscriber} SUBSCRIBERS</h6>}
                                    </Link>
                                    <Link to={`/neet/course/${card.TitleHeading}`} /* state={{ isEnrolled: card.isEnrolled }} key={index} */ className="btn-start list-group-item">START</Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>

    )
}

export default NeetCards